<script setup>
  import { onMounted } from 'vue'
  import utils from '@/common/util/utils'
  import { useRoute, useRouter } from 'vue-router/composables'

  /*
  description  Query Parameter를 사용하여 바로 로그인 후 returnUrl로 리다이렉트한다.
  history      다른 디바이스(stv, ivi)에서 QR로 서비스 진입했을 경우 동일 계정으로 로그인 시키기위해 만들어졌다.
  warn         credential 로그인시 기존 credential 만료됨
  */

  const router = useRouter()
  const route = useRoute()

  const onFail = async (error) => {
    let message = '서버에서 알 수 없는 오류가 발생했습니다.'
    if (error.response && error.response.status === 550) {
      const rawMessage = error.response.data.resultmessage
      const replacedMessage = rawMessage
        .replace('\\\\n', '\n')
        .replace('\\n', '\n')
      if (replacedMessage) {
        message = replacedMessage
      }
    }
    utils.alert(message, () => {
      router.replace('/')
    })
  }

  onMounted(async () => {
    const { returnUrl = '', type, id = '', password, profile } = route.query
    const result = await utils.login.loginProc(
      {
        userType: type,
        userId: id,
        userPassword: password,
        profile,
        // pushid, // api payload에는 있으나 사용 여부 확인 필요
        // saveId,
        // autoLogin,
      },
      onFail,
    )

    if (result?.status === 200) {
      if (returnUrl) {
        location.href = returnUrl
        return
      }
      await router.replace('/')
    }
  })
</script>
